import { Box, Flex, ModalCloseButton, Tooltip } from "@chakra-ui/react";
import React from "react";

/** Top bar of the review modal (title on the left, the modal's close button on the right). */
export default function ReviewHeader(props: {
  children: React.ReactNode;
  /** Why closing is not possible right now (e.g. "Saving…"); disables the close button. */
  closeDisabledReason?: string | null;
}) {
  const closeDisabledReason = props.closeDisabledReason ?? null;

  return (
    <Flex
      align="center"
      bg="white"
      borderBottomWidth={1}
      borderColor="gray.200"
      flexShrink={0}
      gap={3}
      minH="60px"
      pl={6}
      pr={16}
      py={3}
    >
      {props.children}
      <Tooltip
        hasArrow
        isDisabled={closeDisabledReason === null}
        label={closeDisabledReason}
        placement="bottom-end"
      >
        {/* A disabled button fires no pointer events, so the tooltip hangs off this wrapper. */}
        <Box position="absolute" right={4} top="14px">
          <ModalCloseButton
            borderRadius="full"
            isDisabled={closeDisabledReason !== null}
            position="static"
          />
        </Box>
      </Tooltip>
    </Flex>
  );
}
